import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Button,
  TextField,
  Dialog,
  CircularProgress,
} from '@mui/material';
import {

  Card,
  Divider,
  useTheme,
} from "@mui/material";
import { ResetPasswordByUserRequest } from "src/models/resetpassword";
import { resetPasswordByUser } from "src/services/registeration/registerationService";

import { DashboardContainer } from 'src/layouts/components/content';
import {
  getAllPendingProfileEdits,
  getDoctorEditDetails,
  approveDoctorProfileEdit,
  getAllCustomEdit,
  approveDoctorEdits,
  getAllCustomReport,
  generateDoctorReport,
  getAllNewDoctors,
  ViewDoctorById,
  updateDoctor,
  rejectDoctorProfileEdit,
  updateDoctorProcessStatus,
} from 'src/services/admin/adminService';
import toast from 'react-hot-toast';
import { MaterialReactTable } from 'material-react-table';
import { Iconify } from 'src/components/iconify';
import { useStore } from 'src/store/StoreContext';
import { DoctorProfileModel } from 'src/models/doctorProfile';
import { data } from 'react-router';
import { getAllAdmins } from 'src/services/super_admin/superAdminService';


type DoctorProfileEdit = {
  editId: number;
  doctorName: string;
  email: string;
  oldData: any;
  newData: any;
  dateOfRequest: number;
  requestType: string;
  createdDate: string;
};

type DoctorEditDetails = {
  editId: number;
  oldData: Record<string, any>;
  newData: Record<string, any>;
};

type DoctorReport = {
  doctorName: string;
  startDate: number;
  endDate: number;
  reportPurpose: string;
  dateOfRequest: number;
  requestType: string;
};

interface DoctorDto {
  UserId: number;
  emailAddress: string;
  mobileNumber: string;
  image?: string;
  firstname: string;
  lastname: string;
  MedirecordId?: string;
  specialist?: string;
  providerNumber?: string;
  prescriberNumber?: string;
  ahpraregistrationNumber?: string;
  ahpravalidUntilDate?: number;
  state?: string;
  postalcode?: string;
  suburb?: string;
  accountHolderName?: string;
  accountNumber?: string;
  bsbNumber?: string;
  bankName?: string;
  ProviderName?: string;
  HPI_INo?: string;
  ACN_ABN?: string;
  Signature?: string;
  InsuranceExpiryDate?: number;
}


interface ApiResponse<T> {
  ok: boolean;
  data?: T;
  message?: string;
  success?: boolean;
}
const fieldLabels: Record<string, string> = {
  firstname: "First Name",
  lastname: "Last Name",
  emailAddress: "Email Address",
  mobileNumber: "Mobile Number",
  specialist: "Specialist",
  providerNumber: "Provider Number",
  prescriberNumber: "Prescriber Number",
  ahpraRegistrationNumber: "AHPRA Registration Number",
  ahpravalidUntilDate: "AHPRA Valid Until",
  state: "State",
  postalcode: "Postcode",
  suburb: "Suburb",
  accountHolderName: "Account Holder Name",
  accountNumber: "Account Number",
  bsbNumber: "BSB Number",
  bankName: "Bank Name",
  addressLine: "Address Line",
  acN_ABN: "ACN/ABN",
  providerName: "Provider Name",
  insuranceExpiryDate: "Insurance Expiry Date",
  hpI_INo: "HPI Number",
  medirecordId: "Medirecord ID", // ✅ Human-readable label
  aHPRARegisterDate: "AHPRA Register Date",
  availability: "Availability",
  sourceOfInformation: "Source Of Information",
  image: "Image",
  signature: "Signature",
  ahpraValidUntilDate: "AHPRA Valid Until",


};

const Dashboard = () => {
  const [pendingEdits, setPendingEdits] = useState<DoctorProfileEdit[]>([]);
  const [selectedEdit, setSelectedEdit] = useState<any>(null);
  const [showPendingEdits, setShowPendingEdits] = useState(false);
  const [customRequests, setCustomRequests] = useState<any[]>([]);
  const [showCustomRequests, setShowCustomRequests] = useState(false);
  const [reports, setReports] = useState<any[]>([]);
  const [showReports, setShowReports] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<DoctorProfileModel | null>(null);
  const [newDocotors, setnewDocotors] = useState<any[]>([]);
  const [showNewDoctors, setshowNewDoctors] = useState(false);
  const store = useStore();
  const user = store?.user;
  const userId = parseInt(user?.user?.nameid || "0", 10);
  const [showRejectReason, setShowRejectReason] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [medirecordIdError, setMedirecordIdError] = useState('');
  const [editedProfileData, setEditedProfileData] = useState<any>({});
  const nonEditableFields = ['firstname', 'lastname', 'emailaddress'];
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [signatureFile, setSignatureFile] = useState<File | null>(null);
 const [reportLoadingKey, setReportLoadingKey] = useState<string | null>(null);
  const IMAGE_STYLE = {
    width: 120,
    height: 120,
    objectFit: "contain" as const,
    border: "1px solid #ccc",
    borderRadius: 6,
  };

  const SIGNATURE_STYLE = {
    width: 120,
    height: 120,
    objectFit: "contain" as const,
    border: "1px solid #ccc",
    borderRadius: 6,
  };





  // ---- Reset Password Popup States ----
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const confirmRef = useRef<HTMLInputElement>(null);

  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    special: false,
  });
  const validatePassword = (password: string) => {
    setPasswordValidations({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const normalizeKey = (key: string) =>
    key.replace(/_/g, "").toLowerCase();

  const getFieldLabel = (key: string) => {
    const normalized = normalizeKey(key);

    // Try to find matching label from fieldLabels
    const match = Object.keys(fieldLabels).find(
      (k) => normalizeKey(k) === normalized
    );

    return match ? fieldLabels[match] : key;
  };
//     const toInputDate = (value: any): string => {
//   if (!value) return "";

//   // unix milliseconds
//   if (typeof value === "number") {
//     const d = new Date(value);
//     return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
//       d.getDate()
//     ).padStart(2, "0")}`;
//   }

//   if (typeof value === "string") {
//     // yyyy-MM-dd or ISO
//     if (!isNaN(Date.parse(value))) {
//       const d = new Date(value);
//       return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
//         d.getDate()
//       ).padStart(2, "0")}`;
//     }

//     // dd-MM-yyyy
//     if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
//       const [dd, mm, yyyy] = value.split("-");
//       return `${yyyy}-${mm}-${dd}`;
//     }

//     // ✅ dd/MM/yyyy (THIS WAS MISSING)
//     if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
//       const [dd, mm, yyyy] = value.split("/");
//       return `${yyyy}-${mm}-${dd}`;
//     }
//   }

//   return "";
// };
   const toInputDate = (value: any): string => {
  if (!value) return "";

  // unix ms
  if (typeof value === "number") {
    const d = new Date(value);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  }

  // dd-MM-yyyy → yyyy-MM-dd
  if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [dd, mm, yyyy] = value.split("-");
    return `${yyyy}-${mm}-${dd}`;
  }

  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  

  return "";
};


const formatToDDMMYYYY = (value: any): string => {
  if (!value) return "--";

  // unix timestamp
  if (typeof value === "number") {
    const d = new Date(value);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  }

  // dd-MM-yyyy → SAFE (return as-is)
  if (typeof value === "string" && /^\d{2}-\d{2}-\d{4}$/.test(value)) {
    return value;
  }

  // dd/MM/yyyy → normalize
  if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return value.replace(/\//g, "-");
  }

  // yyyy-MM-dd → convert manually
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [yyyy, mm, dd] = value.split("-");
    return `${dd}-${mm}-${yyyy}`;
  }

  return value;
};






  useEffect(() => {
    const checkAdminPasswordResetStatus = async () => {
      try {
        const adminId = user?.user?.nameid;
        if (!adminId) return;

        const res = await getAllAdmins();

        if (res.ok && Array.isArray(res.data)) {
          const currentAdmin = res.data.find(
            (admin) => admin.userId?.toString() === adminId.toString()
          );

          if (currentAdmin && !currentAdmin.passwordReset) {
            setShowResetPopup(true);
          }
        }
      } catch (error) {
        // silent fail
      }
    };


    checkAdminPasswordResetStatus();
  }, [user]);
  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setResetLoading(true);

      const email = user?.user?.email ?? "";
      const userId = user?.user?.nameid ?? "";

      const model = new ResetPasswordByUserRequest(email, userId, newPassword);
      const result = await resetPasswordByUser(model);

      if (result.ok) {
        toast.success("Password reset successfully");
        setShowResetPopup(false);
      } else {
        toast.error(result.message || "Failed to reset password");
      }
    } catch {
      toast.error("Something went wrong");
    } finally {
      setResetLoading(false);
    }
  };



  const fetchPendingEdits = async () => {
    try {
      const res = await getAllPendingProfileEdits();
      if (res.ok) {
        setPendingEdits(res.data as DoctorProfileEdit[]);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error('Error fetching pending profile edits');
    }
  };

  const handleVerify = async (editId: string) => {
    const res = await getDoctorEditDetails(editId);

    if (res.ok && res.data) {
      const data = res.data as DoctorEditDetails;

      setSelectedEdit({
        ...data,
        editId,
      });

      setEditedProfileData({ ...data.newData });
    } else {
      toast.error('Invalid data format');
    }
  };

  const handleApprove = async () => {
    if (!selectedEdit) return;

    const formData = new FormData();


    formData.append("EditId", selectedEdit.editId.toString());

   Object.entries(editedProfileData).forEach(([key, value]) => {
  const lowerKey = key.toLowerCase();

  if (lowerKey === "image" || lowerKey === "signature") return;

  if (value === undefined || value === null) return;

  formData.append(`UpdatedData[${key}]`, String(value));
});

    if (imageFile) {
      formData.append("ImageFile", imageFile);
    } else if (editedProfileData.image) {
      formData.append("UpdatedData[image]", editedProfileData.image);
    }

    if (signatureFile) {
      formData.append("SignatureFile", signatureFile);
    } else if (editedProfileData.signature) {
      formData.append("UpdatedData[signature]", editedProfileData.signature);
    }

    const res = await approveDoctorProfileEdit(formData);

    if (res.ok) {
      toast.success("Profile edit approved successfully");
      setSelectedEdit(null);
      setEditedProfileData({});
      setImageFile(null);
      setSignatureFile(null);
      fetchPendingEdits();
    } else {
      toast.error(res.message || "Approval failed");
    }
  };




  const handleReject = async () => {
    try {
      const res = await rejectDoctorProfileEdit(selectedEdit.editId, rejectionReason);
      if (res.ok) {
        toast.error('Profile edit rejected');
        setSelectedEdit(null);
        setShowRejectReason(false);
        setRejectionReason('');
        fetchPendingEdits();
      } else {
        toast.error(res.message || 'Failed to reject edit');
      }
    } catch (err) {
      toast.error('Error rejecting profile edit');
    }
  };


  const handleCustumRequestApprove = async (doctorId: string) => {


    const response: ApiResponse<any> = await approveDoctorEdits(doctorId);
    if (response.ok) {
      toast.success('Profile Edit Requests approved'); // This line is correct for the message
      fetchCustomRequests(); // This refetches the data (which works, but not instant)
    } else {
      toast.error(response.message || 'Failed to approve Profile Edit Requests');
    }

  };

const handleReportApprove = async (
  userId: string,
  fromDate: number,
  toDate: number
) => {
    const key = `${userId}_${fromDate}_${toDate}`;
     if (reportLoadingKey === key) return;
  try {
 setReportLoadingKey(key);
    const res = await generateDoctorReport(userId, fromDate, toDate);

    if (res.ok) {
      toast.success("Report generated and emailed successfully");

      // ✅ REMOVE the approved row from UI
      setReports((prev) =>
        prev.filter(
          (r) =>
            !(
              r.userId === userId &&
              r.startDate === fromDate &&
              r.endDate === toDate
            )
        )
      );

    } else {
      toast.error(res.message || "Failed to generate report");
    }
  } catch (error) {
    toast.error("Error generating report");
  }
  finally {
     setReportLoadingKey(null); // ✅ STOP loader
  }
};


  const handleDoctorApprove = async (userId: string) => {
    try {
      const res = await ViewDoctorById(userId);
      if (res.ok && res.data) {
        setSelectedDoctor(res.data);
      } else {
        toast.error(res.message || "Failed to fetch doctor details");
      }
    } catch (error) {
      toast.error("Error fetching doctor details");
    }
  };

  const fetchCustomRequests = async () => {
    try {
      const res = await getAllCustomEdit();
      if (res.ok) {
        setCustomRequests(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error('Error fetching custom edit requests');
    }
  };

  const fetchReports = async () => {
    try {
      const res = await getAllCustomReport();
      if (res.ok) {
        setReports(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error('Error fetching reports');
    }
  };

  // const fetchNewDoctors = async () => {
  //   try {
  //     const res = await getAllNewDoctors();
  //     if (res.ok) {
  //       console.log("New Doctors Data:", res.data); // <-- log here
  //       setnewDocotors(res.data);
  //     } else {
  //       toast.error(res.message);
  //     }
  //   } catch (error) {
  //     toast.error('Error fetching new doctors');
  //   }
  // };
  const fetchNewDoctors = async () => {
    try {
      const res = await getAllNewDoctors();
      if (res.ok && Array.isArray(res.data)) {
        const now = Date.now(); // current time in ms

        const filteredDoctors = res.data.filter((doc: any) => {
          const completedDate = Number(doc.completed_date);
          if (!completedDate) return true;
          const diffMs = now - completedDate;
          const diffDays = diffMs / (1000 * 60 * 60 * 24);
          return diffDays < 2;
        });

        setnewDocotors(filteredDoctors);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Error fetching new doctors");
    }
  };

  const formatDate = (timestamp: number | null) => {
    if (!timestamp) return '';
    const tsStr = timestamp.toString();
    if (/^\d{8}$/.test(tsStr)) {
      // Parse as YYYYMMDD
      const year = parseInt(tsStr.substring(0, 4));
      const month = parseInt(tsStr.substring(4, 6)) - 1; // JS month 0-based
      const day = parseInt(tsStr.substring(6, 8));
      const date = new Date(year, month, day);
      return date.toLocaleDateString();
    }

    // If timestamp looks like seconds (<=10 digits), multiply by 1000
    if (tsStr.length <= 10) {
      return new Date(timestamp * 1000).toLocaleDateString();
    }

    // Else assume timestamp is milliseconds
    return new Date(timestamp).toLocaleDateString();
  };


  useEffect(() => {
    fetchPendingEdits();
    fetchCustomRequests();
    fetchReports();
    fetchNewDoctors();
  }, []);

//   useEffect(() => {
//   fetchPendingEdits();
//   fetchCustomRequests();
//   fetchReports();
//   fetchNewDoctors();

//   const interval = setInterval(() => {
//     fetchPendingEdits();
//     fetchCustomRequests();
//     fetchReports();
//     fetchNewDoctors();
//   }); 
//   return () => clearInterval(interval);
// }, []);


  return (
    <DashboardContainer icon="fluent-color:poll-32" title="Dashboard">
      {showCustomRequests ? (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Make doctor profile edits
          </Typography>

          <MaterialReactTable
            columns={[
              { accessorKey: 'doctorName', header: 'Doctor Name' },
              { accessorKey: 'requestField', header: 'Field Value' },
              { accessorKey: 'editedValue', header: 'New Value' },
              { accessorKey: 'status', header: 'Status' },
              {
                accessorKey: 'createdDate',
                header: 'Date of Request',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              {
                header: 'Action',
                Cell: ({ row }: any) => (
                  <Tooltip title="Verify Edit">
                    <IconButton
                      onClick={() =>
                        handleCustumRequestApprove(row.original.doctorId)
                      }
                    >
                      <Iconify width={30} icon="fluent:checkmark-circle-24-filled" />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            muiTableHeadRowProps={{
              sx: { bgcolor: 'primary.light', color: 'white' },
            }}
            muiTableHeadCellProps={{
              sx: { color: 'black' },
            }}
            muiTableBodyRowProps={{
              sx: { bgcolor: 'white' },
            }}
            muiTableBodyCellProps={{
              sx: { borderBottom: '1px solid #ccc' },
            }}
            data={customRequests}
            enableTopToolbar={false}
            enableSorting={false}
          />

          <Box sx={{ mt: 4 }}>
            <Button
              variant="text"
              color="primary"
              onClick={() => setShowCustomRequests(false)}
            >
              ← Back to Dashboard
            </Button>
          </Box>
        </>
      ) : showReports ? (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Send reports to doctors
          </Typography>
          <MaterialReactTable
            columns={[
              { accessorKey: 'doctorName', header: 'Doctor Name' },
              {
                accessorKey: 'startDate',
                header: 'Start Date',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              {
                accessorKey: 'endDate',
                header: 'End Date',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              { accessorKey: 'reportPurpose', header: 'Report Purpose' },
              {
                accessorKey: 'dateOfRequest',
                header: 'Date of Request',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              { accessorKey: 'requestType', header: 'Request Type' },
              // Add more columns based on your DoctorReport type
            {
  header: 'Action',
  Cell: ({ row }: any) => (
    <Tooltip title={reportLoadingKey ? "Generating..." : "Generate Report"}>
      <span>
        <IconButton
          disabled={
            reportLoadingKey ===
            `${row.original.userId}_${row.original.startDate}_${row.original.endDate}`
          }
          onClick={() =>
            handleReportApprove(
              row.original.userId,
              row.original.startDate,
              row.original.endDate
            )
          }
        >
          {reportLoadingKey ===
          `${row.original.userId}_${row.original.startDate}_${row.original.endDate}` ? (
            <CircularProgress size={24} />
          ) : (
            <Iconify width={30} icon="fluent:checkmark-circle-24-filled" />
          )}
        </IconButton>
      </span>
    </Tooltip>
  ),
}
            ]}
            muiTableHeadRowProps={{
              sx: { bgcolor: 'primary.light', color: 'white' },
            }}
            muiTableHeadCellProps={{
              sx: { color: 'black' },
            }}
            muiTableBodyRowProps={{
              sx: { bgcolor: 'white' },
            }}
            muiTableBodyCellProps={{
              sx: { borderBottom: '1px solid #ccc' },
            }}
            data={reports}
            enableTopToolbar={false}
            enableSorting={false}

          />
          <Box sx={{ mt: 4 }}>
            <Button
              variant="text"
              color="primary"
              onClick={() => setShowReports(false)}
            >
              ← Back to Dashboard
            </Button>
          </Box>

        </>
      ) : showNewDoctors ? (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Review new doctor profiles
          </Typography>

          <MaterialReactTable
            columns={[
              { accessorKey: 'doctorName', header: 'Doctor Name' },
              { accessorKey: 'emailAddress', header: 'Email' },
              {
                accessorKey: 'createdDate',
                header: 'Date Of Creation',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              {
                accessorKey: 'process_Status',
                header: 'Status',
                Cell: ({ cell }: any) => cell.getValue() || 'Newly Added Doctor',
              },
              {
                header: 'Action',
                Cell: ({ row }: any) => (
                  <Tooltip title="View Doctor">
                    <IconButton onClick={() => handleDoctorApprove(row.original.userId)}>
                      <Iconify width={30} icon="fluent:eye-24-filled" />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={newDocotors}
            enableTopToolbar={false}
            enableSorting={false}
            muiTableHeadRowProps={{ sx: { bgcolor: 'primary.light' } }}
            muiTableBodyRowProps={{ sx: { bgcolor: 'white' } }}
          />

          {selectedDoctor && (
            <Box
              sx={{
                mt: 4,
                p: 2,
                border: '1px solid #ccc',
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" sx={{ mb: 2 }}>
                Doctor Details
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 2,
                }}
              >
                {Object.entries(selectedDoctor)
                  .filter(([key]) =>
                    [
                      'firstname',
                      'lastname',
                      'emailAddress',
                      'mobileNumber',
                      'ahpraregistrationNumber',
                      'ahpravalidUntilDate',
                      'availability',
                      'sourceOfInformation',
                    ].some((k) => k.toLowerCase() === key.toLowerCase())
                  )
                  .map(([key, value]) => (
                    <Box key={key} sx={{ flex: '1 1 300px' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                        {fieldLabels[key] || key}
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 1 }}>
                        {key.toLowerCase().includes("date")
  ? formatToDDMMYYYY(value)
  : value ?? "--"}

                      </Typography>
                    </Box>
                  ))}

              </Box>

              {/* ✅ Process buttons */}
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    if (!selectedDoctor?.id) {
                      toast.error('Doctor ID not found');
                      return;
                    }
                    const res = await updateDoctorProcessStatus(
                      selectedDoctor.id,
                      'Process Started'
                    );
                    if (res.ok) {
                      toast.success('Process Started!');
                      fetchNewDoctors();
                      setSelectedDoctor(null);
                    } else {
                      toast.error(res.message || 'Failed to update status');
                    }
                  }}
                >
                  Process Started
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    if (!selectedDoctor?.id) {
                      toast.error('Doctor ID not found');
                      return;
                    }
                    const res = await updateDoctorProcessStatus(
                      selectedDoctor.id,
                      'Process Completed'
                    );
                    if (res.ok) {
                      toast.success('Process Completed!');
                      fetchNewDoctors();
                      setSelectedDoctor(null);
                    } else {
                      toast.error(res.message || 'Failed to update status');
                    }
                  }}
                >
                  Process Completed
                </Button>
              </Box>
            </Box>
          )}

          {/* ✅ Back button */}
          <Box sx={{ mt: 4 }}>
            <Button variant="text" onClick={() => setshowNewDoctors(false)}>
              ← Back to Dashboard
            </Button>
          </Box>
        </>

      ) : showPendingEdits ? (
        <>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Approve profile edits
          </Typography>

          <MaterialReactTable
            columns={[
              { accessorKey: 'firstname', header: 'Doctor’s Name' },
              {
                accessorKey: 'dateOfRequest',
                header: 'Date of Request',
                Cell: ({ cell }: any) => formatDate(cell.getValue()),
              },
              {
                header: 'Action',
                Cell: ({ row }: any) => (
                  <Tooltip title="Verify Edit">
                    <IconButton
                      onClick={() =>
                        handleVerify(row.original.editId.toString())
                      }
                    >
                      <Iconify width={30} icon="fluent:eye-24-filled" />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            muiTableHeadRowProps={{
              sx: { bgcolor: 'primary.light', color: 'white' },
            }}
            muiTableHeadCellProps={{
              sx: { color: 'black' },
            }}
            muiTableBodyRowProps={{
              sx: { bgcolor: 'white' },
            }}
            muiTableBodyCellProps={{
              sx: { borderBottom: '1px solid #ccc' },
            }}
            data={pendingEdits}
            enableTopToolbar={false}
            enableSorting={false}

          />

          {selectedEdit && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                border: '1px solid #ccc',
                borderRadius: 2,
              }}
            >
              <Typography variant="h6">Verify Profile Edit</Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: 4,
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Old Profile
                  </Typography>
                  {Object.entries(selectedEdit.oldData).map(([key, value]) => {
                    const isImageField =
                      key.toLowerCase() === "image" || key.toLowerCase() === "signature";

                    return isImageField ? (
                      <Box key={key} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                          {fieldLabels[key] || key}
                        </Typography>

                        {value ? (
                          <img
                            src={value as string}
                            alt={key}
                            style={key === "signature" ? SIGNATURE_STYLE : IMAGE_STYLE}
                          />
                        ) : (
                          <Typography variant="body2">No image</Typography>
                        )}
                      </Box>
                    ) : (
                      <TextField
                        key={key}
                        label={fieldLabels[key] || key}
                        value={value ?? ""}
                        fullWidth
                        margin="dense"
                        InputProps={{ readOnly: true }}
                      />
                    );
                  })}

                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Edited Profile
                  </Typography>

                  
                  {Object.entries(editedProfileData).map(([key, value]) => {
                    const lowerKey = key.toLowerCase();

                    const isNonEditable = nonEditableFields.includes(lowerKey);
                    const isDateField =
                      lowerKey === "insuranceexpirydate" ||
                      lowerKey === "ahpravaliduntildate";

                    const isImage = lowerKey === "image";
                    const isSignature = lowerKey === "signature";

                    /* ================= IMAGE / SIGNATURE ================= */
                    if (isImage || isSignature) {
                      const inputId = isSignature ? "signature-upload" : "image-upload";

                      return (
                        <Box key={key} sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {getFieldLabel(key)}
                          </Typography>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            {typeof value === "string" && value ? (
                              <img
                                src={value}
                                alt={key}
                                style={isSignature ? SIGNATURE_STYLE : IMAGE_STYLE}
                              />
                            ) : (
                              <Typography variant="body2">No image</Typography>
                            )}

                            <input
                              id={inputId}
                              type="file"
                              accept="image/*"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                console.log("FILE SELECTED:", file); // 🔥 you WILL see this now

                                if (!file) return;

                                const previewUrl = URL.createObjectURL(file);


                                if (isImage) {
                                  setImageFile(file);
                                }

                                if (isSignature) {
                                  setSignatureFile(file);
                                }

                                setEditedProfileData((prev: any) => ({
                                  ...prev,
                                  [key]: previewUrl,
                                }));
                              }}
                            />

                            {/* ✅ BUTTON TRIGGERS INPUT */}
                            <label htmlFor={inputId}>
                              <Button variant="outlined" size="small" component="span">
                                Upload {isSignature ? "Signature" : "Image"}
                              </Button>
                            </label>
                          </Box>
                        </Box>
                      );
                    }


                    /* ================= DATE FIELD ================= */
                    if (isDateField) {
  const formattedDate = toInputDate(value);

  return (
    <TextField
      key={key}
      type="date"
      label={getFieldLabel(key)}
      fullWidth
      margin="dense"
      value={formattedDate}
      InputLabelProps={{ shrink: true }}
      onChange={(e) => {
        if (!e.target.value) return;

        const [year, month, day] = e.target.value.split("-").map(Number);

        // store as unix ms (LOCAL, NOT UTC)
        const unixMs = new Date(year, month - 1, day).getTime();

        setEditedProfileData((prev: any) => ({
          ...prev,
          [key]: unixMs,
        }));
      }}
    />
  );
}


                    /* ================= NORMAL TEXT ================= */
                    return (
                      <TextField
                        key={key}
                        label={getFieldLabel(key)}
                        value={value ?? ""}
                        onChange={(e) =>
                          setEditedProfileData((prev: any) => ({
                            ...prev,
                            [key]: e.target.value,
                          }))
                        }
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        disabled={isNonEditable}
                        InputProps={{ readOnly: isNonEditable }}
                      />
                    );
                  })}
                </Box>
              </Box>
              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <Button variant="contained" color="primary" onClick={handleApprove}>
                  Approve
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setShowRejectReason(true)}
                >
                  Reject
                </Button>
                <Button variant="text" onClick={() => setSelectedEdit(null)}>
                  Cancel
                </Button>
              </Box>

              {showRejectReason && (
                <Box sx={{ mt: 2 }}>
                  <TextField
                    label="Reason for Rejection"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    margin="normal"
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleReject}
                    disabled={!rejectionReason.trim()}
                  >
                    Submit Rejection
                  </Button>
                </Box>
              )}
            </Box>

          )}

          <Box sx={{ mt: 4 }}>
            <Button
              variant="text"
              color="primary"
              onClick={() => {
                setShowPendingEdits(false);
                setSelectedEdit(null);
              }}
            >
              ← Back to Dashboard
            </Button>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mb: 3,
            flexWrap: 'wrap',
          }}
        >
          {/* Pending Profile Edits Card */}
          <Box
            onClick={() => setShowPendingEdits(true)}
            sx={{
              width: 250,
              height: 250,
              p: 2,
              borderRadius: 2,
              border: '1px solid #ccc',
              cursor: 'pointer',
              backgroundColor: '#f5f5f5',
              '&:hover': { backgroundColor: '#e0e0e0' },
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              Approve profile edits - edited by doctors
            </Typography>
            <Typography variant="h4" color="primary" sx={{ my: 1 }}>
              {pendingEdits.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click to review and approve doctor profile edit requests.
            </Typography>
          </Box>

          {/* Custom Requests Card (Light Red) */}
          {/* <Box
            onClick={() => {
              fetchCustomRequests();
              setShowCustomRequests(true);
            }}
            sx={{
              width: 250,
              height: 250,
              p: 2,
              borderRadius: 2,
              border: '1px solid #ccc',
              backgroundColor: '#FFCDD2',
              color: '#000',
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#ef9a9a' },
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
            Make doctor profile edits - requested by doctors
            </Typography>
            <Typography variant="h4" color="primary" sx={{ my: 1 }}>
              {customRequests.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click to review and approve doctorProfile Edit Requests.
            </Typography>
          </Box> */}

          {/* Reports Card (Light Blue) */}
          <Box
            onClick={() => {
              fetchReports();
              setShowReports(true);
            }}
            sx={{
              width: 250,
              height: 250,
              p: 2,
              borderRadius: 2,
              border: '1px solid #ccc',
              backgroundColor: '#BBDEFB', // Light Blue
              color: '#000',
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#90CAF9' }, // Slightly darker blue for hover
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              Send reports to doctors
            </Typography>
            <Typography variant="h4" color="primary" sx={{ my: 1 }}>
              {reports.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click to review and approve doctor reports.
            </Typography>
          </Box>
          {/* Reports Card (Light Blue) */}
          <Box
            onClick={() => {
              fetchNewDoctors();
              setshowNewDoctors(true);
            }}
            sx={{
              width: 250,
              height: 250,
              p: 2,
              borderRadius: 2,
              border: '1px solid #ccc',
              backgroundColor: '#B3E5FC', // Light Blue
              color: '#000',
              cursor: 'pointer',
              '&:hover': { backgroundColor: '#81D4FA' }, // Slightly darker blue for hover
            }}
          >
            <Typography variant="subtitle1" fontWeight={600}>
              Review new doctor profiles/ onboard doctors
            </Typography>
            <Typography variant="h4" color="primary" sx={{ my: 1 }}>
              {newDocotors.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click to review doctors.
            </Typography>
          </Box>

        </Box>
      )}
      <Dialog
        open={showResetPopup}
        onClose={() => { }}
        disableEscapeKeyDown
        PaperProps={{
          onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation(),
        }}>
        <Box
          p={3}
          minWidth={380}
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            handleResetPassword();
          }}
        >
          <Typography variant="h6" gutterBottom>
            Reset Your Password
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please set a new password for your account.
          </Typography>

          {/* ---- New Password Field ---- */}
          <TextField
            fullWidth
            label="New Password"
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => {
              const val = e.target.value;
              setNewPassword(val);
              validatePassword(val);
            }}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     e.preventDefault();
            //     confirmRef.current?.focus();
            //   }
            // }}
            InputProps={{
              endAdornment: (
                <Iconify
                  icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                  onClick={() => setShowPassword((prev) => !prev)}
                  sx={{ cursor: "pointer", color: "text.secondary" }}
                />
              ),
            }}
            sx={{ mb: newPassword ? 1 : 3 }}
          />

          {/* ---- Show Validation Rules Only When User Types ---- */}
          {newPassword && (
            <Box sx={{ mb: 2, pl: 1 }}>
              {[
                {
                  label: "At least 8 characters",
                  valid: passwordValidations.length,
                },
                {
                  label: "At least 1 uppercase letter",
                  valid: passwordValidations.uppercase,
                },
                {
                  label: "At least 1 lowercase letter",
                  valid: passwordValidations.lowercase,
                },
                {
                  label: "At least 1 number",
                  valid: passwordValidations.number,
                },
                {
                  label: "At least 1 special character",
                  valid: passwordValidations.special,
                },
              ].map((rule, idx) => (
                <Typography
                  key={idx}
                  variant="caption"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: rule.valid ? "success.main" : "error.main",
                  }}
                >
                  <Iconify
                    icon={rule.valid ? "mdi:check-circle" : "mdi:close-circle"}
                    width={14}
                    height={14}
                  />
                  {rule.label}
                </Typography>
              ))}
            </Box>
          )}

          {/* ---- Confirm Password Field ---- */}
          <TextField
            fullWidth
            inputRef={confirmRef}
            label="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <Iconify
                  icon={
                    showConfirmPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"
                  }
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  sx={{ cursor: "pointer", color: "text.secondary" }}
                />
              ),
            }}
            error={confirmPassword !== "" && confirmPassword !== newPassword}
            helperText={
              confirmPassword !== "" && confirmPassword !== newPassword
                ? "Passwords do not match"
                : ""
            }
            sx={{ mb: 3 }}
          />

          <Box display="flex" justifyContent="flex-end" gap={2}>
            {/* <Button onClick={() => setShowResetPopup(false)} disabled={resetLoading}>
              Cancel
            </Button> */}
            <Button
              type="submit"
              variant="contained"
              disabled={
                resetLoading ||
                !Object.values(passwordValidations).every((v) => v === true) ||
                confirmPassword !== newPassword
              }
            >
              {resetLoading ? "Saving..." : "Save Password"}
            </Button>

          </Box>
        </Box>
      </Dialog>

    </DashboardContainer>
  );
};

export default Dashboard;
